import { render, staticRenderFns } from "./VmTextArea.vue?vue&type=template&id=7c372bd6&scoped=true&"
import script from "./VmTextArea.vue?vue&type=script&lang=js&"
export * from "./VmTextArea.vue?vue&type=script&lang=js&"
import style0 from "./VmTextArea.vue?vue&type=style&index=0&id=7c372bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c372bd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
